export default "__VITE_ASSET__DPG2XBAk__"